var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLiveCasino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.28784 17.9654H12.5378V20.8092H9.28784V17.9654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22544 17.9654H8.47534V20.8092H5.22544V17.9654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3504 17.9654H16.6003V20.8092H13.3504V17.9654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4442 14.7154H6.44409C4.19503 14.7154 1.56909 15.8857 1.56909 19.1842V19.5902C1.56909 22.8887 4.19503 24.0592 6.44409 24.0592H19.4442C21.6932 24.0592 24.3192 22.8887 24.3192 19.5902V19.1842C24.3192 15.8857 21.6932 14.7154 19.4442 14.7154ZM14.9754 15.5279H20.2566C20.4811 15.5279 20.6628 15.7097 20.6628 15.9342C20.6628 16.1585 20.4811 16.3402 20.2566 16.3402H14.9754C14.751 16.3402 14.5691 16.1585 14.5691 15.9342C14.5691 15.7097 14.751 15.5279 14.9754 15.5279ZM5.63159 15.5279H10.9128C11.1373 15.5279 11.3192 15.7097 11.3192 15.9342C11.3192 16.1585 11.1373 16.3402 10.9128 16.3402H5.63159C5.4073 16.3402 5.22544 16.1585 5.22544 15.9342C5.22544 15.7097 5.4073 15.5279 5.63159 15.5279ZM20.7589 23.0911C20.3281 23.1942 19.8871 23.2465 19.4442 23.2465H6.44409C6.00113 23.2465 5.56026 23.1942 5.12941 23.0911C4.9856 23.0595 4.87021 22.9524 4.82767 22.8114C4.78524 22.6704 4.82233 22.5173 4.92466 22.4117C5.02718 22.3058 5.1789 22.2637 5.32109 22.3016C5.68929 22.3888 6.06607 22.4333 6.44409 22.434H19.4442C19.8222 22.4333 20.1991 22.3888 20.5672 22.3016C20.7093 22.2637 20.8611 22.3058 20.9636 22.4117C21.066 22.5173 21.103 22.6704 21.0606 22.8114C21.0181 22.9524 20.9027 23.0595 20.7589 23.0911ZM21.4753 20.8092C21.4753 21.2578 21.1116 21.6217 20.6628 21.6217H5.22544C4.77665 21.6217 4.41284 21.2578 4.41284 20.8092V17.9654C4.41284 17.5165 4.77665 17.1527 5.22544 17.1527H12.5378V15.9342C12.5378 15.7097 12.7198 15.5279 12.9441 15.5279C13.1686 15.5279 13.3504 15.7097 13.3504 15.9342V17.1527H20.6628C21.1116 17.1527 21.4753 17.5165 21.4753 17.9654V20.8092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4129 17.9654H20.6628V20.8092H17.4129V17.9654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4379 4.24984C16.4379 6.04473 14.8988 7.49978 13.0002 7.49978C11.1017 7.49978 9.56262 6.04473 9.56262 4.24984C9.56262 2.45467 11.1017 0.999619 13.0002 0.999619C14.8988 0.999619 16.4379 2.45467 16.4379 4.24984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25012 11.6361C9.25012 11.3095 9.5302 11.0452 9.87512 11.0452C10.2205 11.0452 10.5003 11.3095 10.5003 11.6361V13.9996H15.5002V11.6361C15.5002 11.3095 15.7801 11.0452 16.1254 11.0452C16.4703 11.0452 16.7502 11.3095 16.7502 11.6361V13.9996H18.0002V10.6904C18.0002 9.58068 17.0489 8.68157 15.8752 8.68157H10.1253C8.95155 8.68157 8.00024 9.58068 8.00024 10.6904V13.9996H9.25012V11.6361Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.485596 0.242783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveCasino);
export default __webpack_public_path__ + "static/media/icon-live-casino.e2f539bb183e0ef3c45ea36c42aaa299.svg";
export { ForwardRef as ReactComponent };